import React from 'react';

export enum ToolkitsEnum {
  'seo',
  'content',
  'local',
  'traffic-and-market',
  'advertising',
  'ai',
  'social',
  'pr',
}

export type ToolkitsT = keyof typeof ToolkitsEnum;

export type ToolkitCardT = {
  value: ToolkitsT;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
};
